




















import Vue from 'vue';
export default Vue.extend({
  props: {
    anchorLeft: {
      type: Boolean,
      default: false
    }
  }
});
